import { faSignIn } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Helmet } from 'react-helmet'
import splash from '../../media/classroomSplash.jpg'
import { ReactComponent as QuoteIcon } from '../../media/icon-science.svg'
import oftmcssLogo from '../../media/oftmcss.svg'
import { Brand, Content, Templates } from 'ui'
import * as Forms from './Forms'
import { randomTestimonial } from './testimonials'

/**
 * The initial step for creating an account as a teacher.
 */
export const InitialSignUpView: React.FC = () => {
  const testimonial = randomTestimonial()
  return (
    <Templates.SplashImageView
      backgroundImageSrc={splash}
      footerImageSrc={oftmcssLogo}
      splashContent={
        <Templates.SplashQuote
          quote={testimonial.quote}
          author={testimonial.author}
          title={testimonial.title}
          icon={
            <QuoteIcon
              style={{
                width: 'auto',
                height: '60px',
                display: 'block',
              }}
              className="fill-current text-white"
            />
          }
        />
      }
    >
      <Helmet>
        <title>Start Connecting Today - MCSS PRO Connect</title>
      </Helmet>
      <Content.Region>
        <Brand.EpcLogo />
        <Content.Heading>Start Connecting Today</Content.Heading>
        <Content.Body>
          Educator PRO Connect supports teachers in Arizona, by connecting them
          with STEM and industry professionals to enhance real-world classroom
          applications and bring awareness to college and career pathways.
        </Content.Body>
        <Forms.InitialSignUp />
        <Content.List>
          <Content.ListItem>
            <Content.ListIcon>
              <FontAwesomeIcon icon={faSignIn} />
            </Content.ListIcon>
            <Content.Body>
              Already have an account?{' '}
              <Content.Link to="/login">Log in.</Content.Link>
            </Content.Body>
          </Content.ListItem>
        </Content.List>
      </Content.Region>
    </Templates.SplashImageView>
  )
}
